import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { Stack, Typography } from "@mui/material";
import "./styles.scss";
import NewStatement from "./NewStatement";

type TransactionDrawerProps = {
  handleDrawerClose: Function;
};

const StatementForm = (props: TransactionDrawerProps) => {
  const { handleDrawerClose } = props;

  const drawerComp = (
    <Stack>
      <Box className="drawer-header" role="presentation">
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          fontWeight={700}
        >
          Transaction Detail
        </Typography>
      </Box>
      <NewStatement handleDrawerClose={handleDrawerClose} />
    </Stack>
  );

  return (
    <div className="transaction-drawer">
      <React.Fragment>
        <Drawer
          anchor="right"
          variant="temporary"
          open={true}

        >
          {drawerComp}
        </Drawer>
      </React.Fragment>
    </div>
  );
};

export default StatementForm;
